import {Link as RouterLink} from "react-router-dom";
import MUILink from '@mui/material/Link';
import React from 'react';

const Link = React.forwardRef((props, ref) => {
    const {children, ...rest} = props;
    return (
        <MUILink component={RouterLink} ref={ref} {...rest}>
            {children}
        </MUILink>
    );
});

export default Link;